import { render, staticRenderFns } from "./IdCardKeyInfo.vue?vue&type=template&id=7f19ebbc&scoped=true"
import script from "./IdCardKeyInfo.vue.js?vue&type=script&lang=js&external"
export * from "./IdCardKeyInfo.vue.js?vue&type=script&lang=js&external"
import style0 from "./IdCardKeyInfo.vue?vue&type=style&index=0&id=7f19ebbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f19ebbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VForm,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VTextField})
